<template>
  <div class="slider-dog">
    <transition name="slide">
      <vdog-video-result-slide
        class="slide"
        v-if="isSlideVisible(2)"
        :roundNo="data.roundNo"
        :roundResult="data.roundResult"
        :match="data.match"/>
    </transition>

    <transition name="slide">
      <vdog-info-slider
        class="slide"
        v-if="isSlideVisible(3)"
        :currency="data.currency"/>
    </transition>

    <transition name='slide'>
      <vdog-jackpots-fall
        class="slide"
        :currency="data.currency"
        v-if="isSlideVisible(1)"
        :showSlider="data.fallenJackpots.showSlider"
        :ticketNo="ticketNo"
        :ticketLocation="ticketLocation"
        :jackpotAmount="jackpotAmount" />
    </transition>
  </div>
</template>

<script>
import VDogInfoSlider from '@/components/grayhound/slides/VDogInfoSlider.vue'
import VDogVideoResultSlide from '@/components/grayhound/slides/VDogVideoResultSlide.vue'
import VDogJackpotsFall from '@/components/grayhound/slides/VDogJackpotsFall.vue'

export default {
  components: {
    'vdog-info-slider': VDogInfoSlider,
    'vdog-video-result-slide': VDogVideoResultSlide,
    'vdog-jackpots-fall': VDogJackpotsFall
  },
  methods: {
    isSlideVisible (slide) {
      let activeSlide = 1
      if (this.data.showFallenJackpots) {
        activeSlide = 1
      } else if (!this.data.showSlider &&
      this.data.roundResult &&
      this.data.match &&
      this.data.showMatchResult) {
        activeSlide = 2
      } else if (this.data.showSlider && !this.data.showMatchResult) {
        activeSlide = 3
      }
      return slide === activeSlide
    }
  },
  computed: {
    ticketNo: function () {
      return this.data.fallenJackpots.ticketNo || ''
    },
    ticketLocation: function () {
      return this.data.fallenJackpots.ticketLocation || ''
    },
    jackpotAmount: function () {
      return this.data.fallenJackpots.jackpotAmount || 0
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  }
}
</script>
